import styled from 'styled-components';
import { PromoCodeStyled } from '../PromoCodeStyled';

export const PromoCodeStyledAP = styled(PromoCodeStyled)`

    .promoCode {
        &__title {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        &__input_label_success {
            width: 100%;
            left: 0;
            background: ${({ theme }) => theme.colors.success};
            color: ${({ theme }) => theme.colors.white};
            font-size: ${({ theme }) => theme.fontSizes.textBase};

            &::after {
                border-top: 7px solid ${({ theme }) => theme.colors.success};
            }
        }

        &__input {
            border: 1px solid ${({ theme }) => theme.colors.grey13};
            color: ${({ theme }) => theme.colors.primaryBlack};

            &_error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &__button {
            border: 1px solid ${({ theme }) => theme.colors.primaryBlack};
        }
    }
`;
